/** Extract user-facing message from kserver errorHandler JSON. */
export function getApiErrorMessage(error: unknown, fallback = 'Request failed'): string {
  const err = error as {
    response?: { data?: { message?: string; error?: string; details?: { missing?: { reason: string }[] } } };
    message?: string;
  };
  const data = err?.response?.data;
  if (data?.message) {
    const missing = data.details?.missing;
    if (Array.isArray(missing) && missing.length > 0) {
      const extra = missing.map((m) => m.reason).join(' ');
      return `${data.message} ${extra}`.trim();
    }
    return data.message;
  }
  if (typeof data?.error === 'string' && data.error.trim()) {
    return data.error;
  }
  if (err?.message) {
    return err.message;
  }
  return fallback;
}
